{
  "title": "Create your Parent Account",
  "subtitle": "Sign in with your existing account to get started.",
  "verification": "We use this to verify you are a real person.",
  "actions": {
    "signupGoogle": "Sign up with Google",
    "signupFacebook": "Sign up with Facebook",
    "signupX": "Sign up with X (Twitter)",
    "login": "Log in"
  },
  "alreadyHaveAccount": "Already have an account?",
  "legal": "By signing up, you agree to our Terms of Service and Privacy Policy. We do not post anything to your social accounts."
}
